var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('HorizontalScroll', {
    directives: [{
      name: "report",
      rawName: "v-report.module",
      value: {},
      expression: "{}",
      modifiers: {
        "module": true
      }
    }],
    staticClass: "a open_list"
  }, _vm._l(_vm.normalList, function (item, index) {
    return _c('BaseItem', {
      directives: [{
        name: "report",
        rawName: "v-report",
        value: _vm.reportData.海报(item.sTitle, item.sActID),
        expression: "reportData.海报(item.sTitle,item.sActID)"
      }],
      key: index,
      attrs: {
        "item": item,
        "fromOpenMod": true
      }
    });
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };